

























































































































































































































































































































































































import { PullRefresh, Overlay, Toast, Popup, List, Dialog, Checkbox, CheckboxGroup, Picker, Button, Icon } from "vant";
import { myTransactionSocket } from "@/views/h5-page/mixins/myTransactionSocket";

export default {
  mixins: [myTransactionSocket],
  components: {
    [Overlay.name]: Overlay,
    [PullRefresh.name]: PullRefresh,
    [Popup.name]: Popup,
    [List.name]: List,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.Component.name]: Dialog.Component,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  props: {
    queryParem: {
      type: Object,
      default: {}
    },
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      overlayShow: false,
      refreshing: false,
      loading: false,
      finished: false,
      groupColumns: ["全部"],
      popupShow: false,
      dialogShow: false,
      submitType: 1,
      checked: false,
      activeIcon: require("@/assets/images/h5Page/checked.png"),
      inactiveIcon: require("@/assets/images/h5Page/noCheck.png"),
      halfSelected: require("@/assets/images/h5Page/half-selected.png"),

      tableData: [],
      initTableData: [],
      totalNum: 0,
      listParem: {
        page: 0,
        size: 1000,
        account_nos: (this as any).queryParem.account || ""
      },
      isHalfSelected: false,
      curRowData: {},

      batchListData: [],
      batchTotalNum: 0,
      batchParem: {
        page: 0,
        size: 1000,
        symbol: "",
        account_nos: (this as any).queryParem.account || ""
      },
      batchGoods: "",
      batchLoading: false,
      batchFinished: false,
      accountAll: [],
      initAccountAll: [],
      isLoadList: false,
      symbolList: [],
      cdShow: false,
      isScroll: false,
      issSonScroll: false,
      showDialog: false,
      checkedDialog: false,
      dialogText: "您确定要撤销本次未成委托？",
      transactionSetInfo: {},
      confirmType: 1,
      batchData: [],
      isListLoad: false,
      tableMouseObj: {
        isDragging: false,
        startX: 0,
        startScrollLeft: 0
      },
      sonTableMouseObj: {
        isDragging: false,
        startX: 0,
        startScrollLeft: 0
      }
    };
  },
  watch: {
    queryParem: {
      handler(val) {
        (this as any).listParem.account_nos = val.account || "";
        (this as any).batchParem.account_nos = val.account || "";
        if ((this as any).activeTab === 1) {
          (this as any).refreshing = true;
          (this as any).onRefresh();
        }
      },
      deep: true
    },
    activeTab: {
      handler(val) {
        clearTimeout((this as any).timer);
        clearTimeout((this as any).batchTimer);
        if (val === 1) {
          (this as any).refreshing = true;
          (this as any).onRefresh();
        }
      },
      deep: true
    }
    // accountAll:{
    //     handler(val){
    //         if(val.length === (this as any).batchListData.length){

    //         }
    //     },
    //     deep:true
    // }
  },
  filters: {
    orderStatus(val) {
      let str = "";
      if (val === 54 || val === 49 || val === 52) {
        str = "color: #02AA39;";
      } else if (val === 55 || val === 56 || val === 50 || val === 51) {
        str = "color: #F69500;";
      } else if (val === 53 || val === 68) {
        str = "color: #333999;";
      } else {
        str = "color: #FF9275";
      }
      return str;
    }
  },
  // 终端提交  -- 48
  // 已受理  -- 49
  // 策略待触发 -- 50
  // 交易所待触发 -- 51
  // 已排队 -- 52
  // 部分成交 -- 53
  // 已成交 -- 54
  // 待撤销(排队临时状态) -- 55
  // 待修改(排队临时状态) -- 56
  // 完全撤单 -- 57
  // 已撤余单 -- 65
  // 指令失败 -- 66
  // 策略删除 -- 67
  // 已挂起 -- 68
  // 到期删除 -- 69
  // 已生效-询价成功 -- 70
  // 已申请-行权、弃权、套利等申请成功 -- 71
  async created() {
    await (this as any).onLoad();
    // let transactionSetObj:any = localStorage.getItem('transactionSet');
    // (this as any).transactionSetInfo = JSON.parse(transactionSetObj);
    (this as any).queryExchangeInfo();
    (this as any).getTradeSettings();
  },
  mounted() {
    const _window = (window as any);
    const _this = (this as any);
    _this.visibilityFn = (e) => {
      if(e.target.visibilityState == 'hidden'){
        clearTimeout(_this.timer);
        clearTimeout(_this.batchTimer);
      }else{
        if ((this as any).activeTab === 1) {
          clearTimeout(_this.timer);
          clearTimeout(_this.batchTimer);
          _this.onRefresh();
        }
      }
    };
    _window.addEventListener('visibilitychange', _this.visibilityFn);
  },
  methods: {
    // 获取用户的交易设置
    getTradeSettings() {
      (this as any).$apis
        .getTransactionSettingList({})
        .then(res => {
          (this as any).transactionSetInfo = res;
          let obj = JSON.stringify(res);
          // create_order 下单确认设置 0 未开启 1开启
          // cancel_order 撤单确认设置 0 未开启 1开启
          // update_order 改单确认设置 0 未开启 1开启
          localStorage.setItem("transactionSet", obj);
        })
        .catch(e => {
          
        });
    },
    //获取交易所信息
    queryExchangeInfo() {
      (this as any).$apis
        .queryExchangeInfo()
        .then(async (res) => {
          let obj = JSON.stringify(res.data.exchange_info);
          localStorage.setItem("exchangeList", obj);
        })
        .catch(e => {
          
        });
    },
    confirmSubmit(type) {
      if ((this as any).transactionSetInfo.cancel_order === 0) {
        if (type === 1) {
          (this as any).batchcancel(1, (this as any).curRowData);
        } else if (type === 2) {
          (this as any).batchcancel(2, {}, (this as any).batchData);
        }
        return;
      }
      (this as any).confirmType = type;
      if (type === 1) {
        (this as any).dialogText = "您确定要撤销本次未成委托？";
      } else if (type === 2) {
        (this as any).dialogText = "您确定要撤销所勾选账户未成委托？";
      }
      (this as any).showDialog = true;
    },
    secondaryConfirm() {
      if ((this as any).checkedDialog) {
        // 撤单确认
        let cancelOrder = (this as any).checkedDialog ? 0 : 1;
        (this as any).$apis
          .setTransactionSetting({
            cancel_order: cancelOrder
          })
          .then(res => {
            
            const { code, msg } = res;
            if (code === 0) {
              (this as any).getTradeSettings();
            } else {
              Dialog.alert({
                message: `提交失败,${msg},请重试`,
                closeOnClickOverlay: true,
                confirmButtonText: "知道了"
              }).then(() => {
                (this as any).getTradeSettings();
              });
            }
          })
          .catch(e => {
            
          });
      }
      if ((this as any).confirmType === 1) {
        (this as any).batchcancel(1, (this as any).curRowData);
      } else if ((this as any).confirmType === 2) {
        (this as any).batchcancel(2, {}, (this as any).batchData);
      }
      (this as any).showDialog = false;
    },
    sonTableScroll() {
      if ((this as any).$refs["sonTableList"].scrollLeft == 0) {
        //滚动至最左边触发
        (this as any).issSonScroll = false;
      } else {
        (this as any).issSonScroll = true;
      }
    },
    // tableScroll(e){
    //     
    //     
    //     
    //     if((this as any).$refs['tableList'].scrollLeft == 0){
    //         //滚动至最左边触发
    //         (this as any).isScroll = false;
    //         
    //         // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
    //         //     item.style.width = 'calc(100vw - '+36+'px)';
    //         // })
    //     } else if((this as any).$refs['tableList'].scrollLeft > ((this as any).$refs['tableList'].scrollWidth - (this as any).$refs['tableList'].clientWidth - 10)){
    //         //滚动至最右边触发
    //         
    //         (this as any).isScroll = true;
    //         // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
    //         //     // let num = (this as any).$refs['tableList'].scrollLeft - 40;
    //         //     item.style.width = 'calc(100% - 36px)';
    //         // })
    //     } else{
    //         (this as any).isScroll = true;
    //         // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
    //         //     let num = (this as any).$refs['tableList'].scrollLeft + (this as any).$refs['tableList'].clientWidth - 36;
    //         //     item.style.width = ''+num+'px';
    //         // })
    //         //没有任何一边达到顶端
    //         
    //     }
    //
    // },
    closeSon() {
      (this as any).groupColumns = ["全部"];
      (this as any).batchParem = {
        page: 0,
        size: 10,
        symbol: "",
        account_nos: (this as any).queryParem.account || ""
      };
      (this as any).batchGoods = "";
    },
    closePopup() {
      (this as any).groupColumns = ["全部"];
      (this as any).batchParem = {
        page: 0,
        size: 10,
        symbol: "",
        account_nos: (this as any).queryParem.account || ""
      };
      (this as any).batchGoods = "";
      // (this as any).queryParem.current_page = 0;
      // (this as any).sonTotalNum = 0;
      // (this as any).sonTableData.list = [];
      if ((this as any).isLoadList) {
        (this as any).refreshing = true;
        (this as any).onRefresh();
      }
    },
    batchSubmit() {
      let accounts: any = [];
      let valArr: any = Array.from(new Set((this as any).accountAll));
      let arr = valArr.filter(item => {
        if (item || item === 0) {
          return item + 1;
        }
      });
      arr.forEach(item => {
        const {
          account_no,
          client_order_no,
          order_side,
          order_price,
          order_qty,
          symbol,
          symbol_name,
          order_no
        } = (this as any).batchListData[item];
        const p = {
          server_flag: 1,
          account_no,
          client_order_no,

          order_side,
          order_price,
          order_qty,
          goods_code: symbol,
          goods_name: symbol_name,
          order_no
        };
        accounts.push(p);
        // (this as any).batchListData.find(val => {
        //     if(val.order_no === item){
        //         accounts.push(val);
        //     }
        // });
      });
      
      (this as any).batchData = accounts;
      (this as any).confirmSubmit(2);
      // (this as any).batchcancel(2,{},accounts)
    },
    checkedChange(val) {
      // if((this as any).checked){
      (this as any).checked = !(this as any).checked;
      // }
      

      if ((this as any).checked) {
        (this as any).$refs.checkboxGroup.toggleAll(true);
        // (this as any).accountAll = JSON.parse(JSON.stringify((this as any).initAccountAll))
      } else {
        (this as any).$refs.checkboxGroup.toggleAll(false);
        // (this as any).accountAll = []
      }
    },
    checkboxChange(valArr) {
      // if(val.length === (this as any).batchListData.length){
      //     (this as any).checked = true;
      //     (this as any).isHalfSelected = false;
      // }else{
      //     (this as any).checked = false;
      //     if(val.length){
      //         (this as any).isHalfSelected = true;
      //     }else{
      //         (this as any).isHalfSelected = false;
      //     }
      // }
      let val: any = Array.from(new Set(valArr));
      val = val.filter(item => {
        if (item || item === 0) {
          return item + 1;
        }
      });
      if (val.length === (this as any).batchListData.length) {
        (this as any).checked = true;
        (this as any).isHalfSelected = false;
      } else {

        if (val.length) {
          if (val.length === (this as any).batchListData.length) {
            (this as any).isHalfSelected = false;
            // (this as any).$refs.checkboxGroup.toggleAll(true);
            (this as any).checked = true;
          } else {

            (this as any).isHalfSelected = true;
          }
          (this as any).checked = false;
        } else {
          (this as any).isHalfSelected = false;
          (this as any).checked = false;
        }
      }
      ;
    },
    openBatch() {
      (this as any).batchFinished = false;
      (this as any).batchParem.page = 0;
      (this as any).batchTotalNum = 0;
      (this as any).batchParem.symbol = "";
      (this as any).batchListData = [];
      (this as any).onBatchLoad();
      (this as any).overlayShow = true;
      setTimeout(() => {
        (this as any).$refs.checkboxGroup.toggleAll(false);
      }, 100);

    },
    onBatchLoad() {
      // setTimeout(() => {
      // (this as any).batchParem.page++;
      (this as any).getBatchListNew();
      // }, 1000);
    },
    async getBatchListNew() {
      const _this = this as any;
      await _this.getBatchList();
      clearTimeout(_this.batchTimer);
      if(localStorage.getItem('token')){
        _this.batchTimer = setTimeout(() => {
          _this.getBatchListNew();
        }, 10000);
      }
    },
    async getBatchList() {
      if (!(this as any).batchParem.account_nos) {
        return;
      }
      sessionStorage.setItem("xid", (this as any).queryParem.type);
      await (this as any).$apis
        .querybatchorders({
          ...(this as any).batchParem,
          is_pending_order: 1
        }, { "X-channel-id": (this as any).queryParem.type })
        .then(res => {
          let symbolList: any = [];
          let batchListData: any = [];
          if (res.data.total === 0) {
            (this as any).cdShow = false;
          } else {
            (this as any).cdShow = true;
          }
          (this as any).groupColumns = ["全部"];

          (this as any).batchTotalNum = res.data.total;
          res.data.symbol_code_names && res.data.symbol_code_names.forEach(item => {
            symbolList.push(item);
            (this as any).groupColumns.push(item.name);
          });
          // (this as any).symbolList = res.data.symbol_code_names;
          if (!(this as any).batchGoods) {
            (this as any).batchGoods = (this as any).groupColumns[0];
          }
          ;

          // (this as any).batchParem.symbol = (this as any).symbolList[0].code;
          res.data.order_infos && res.data.order_infos.forEach(item => {
            (this as any).initAccountAll.push(item.order_no);
            batchListData.push(item);
          });
          (this as any).symbolList = symbolList;
          (this as any).batchListData = batchListData;
          (this as any).batchLoading = false;
          // 
          if ((this as any).batchListData.length >= (this as any).batchTotalNum) {
            (this as any).batchFinished = true;
          }
        })
        .catch(e => {
          Toast.clear();
          (this as any).batchLoading = false;
          
        });
    },
    dialogTab(type, row) {
      // (this as any).dialogShow = true;
      (this as any).curRowData = row;
      (this as any).confirmSubmit(type);
      // (this as any).confirmType = 1;
      // (this as any).dialogText = '您确定要撤销本次未成委托？'
    },
    popupTab() {
      (this as any).dialogShow = false;
      (this as any).batchcancel(1, (this as any).curRowData);

    },
    batchcancel(cancel_type, row = {}, cancel_reqs = []) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中..."
      });
      let parmes = {};
      if (cancel_type == 2) {
        if ((this as any).checked) {
          parmes = {
            cancel_type,
            // isall:true,
            account_no: (this as any).queryParem.account.split(",")
          };
        } else {
          parmes = {
            cancel_type,
            cancel_reqs
          };
        }

      } else if (cancel_type == 1) {
        const {
          account_no,
          client_order_no,
          order_side,
          order_price,
          order_qty,
          symbol,
          symbol_name,
          order_no,
          originSymbol
        }: any = row;
        parmes = {
          cancel_type,
          cancel_reqs: [{
            account_no, client_order_no, server_flag: 1,

            order_side,
            order_price,
            order_qty,
            goods_code: symbol,
            goods_name: symbol_name,
            order_no,
            origin_symbol: originSymbol
          }]
        };
      }
      (this as any).$apis
        .batchcancel(parmes, { "X-channel-id": (this as any).queryParem.type })
        .then(() => {
          Toast.clear();
          Toast({
            message: "订单已提交，请关注订单状态",
            overlay: true,
            closeOnClickOverlay: true,
            duration: 3000
          });
          (this as any).overlayShow = false;
          (this as any).refreshing = true;
          (this as any).onRefresh();
          // Dialog({ title: '',message: '提交成功,请稍后下拉刷新页面更新状态' }).then(()=>{
          //     (this as any).overlayShow = false;
          //     (this as any).refreshing = true;
          //     (this as any).onRefresh();
          //     // if(cancel_type == 1){
          //     //     (this as any).refreshing = true;
          //     //     (this as any).onRefresh();
          //     // }else if(cancel_type == 2){
          //     //     (this as any).isLoadList = true;
          //     //     (this as any).onBatchLoad();
          //     // }
          // });

        })
        .catch(e => {
          Toast.clear();
          Toast({
            message: `提交失败，${e.error_msg}，请重试`,
            overlay: true,
            closeOnClickOverlay: true,
            duration: 3000
          });
          
        });
    },
    mySocketOnMsg(msg) {
      const _this = (this as any);
      if (_this.activeTab == 1) {
        clearTimeout(_this.timer);
        clearTimeout(_this.batchTimer);
        _this.onRefresh();
      }
    },

    async getListNew() {
      await (this as any).getList();
      clearTimeout((this as any).timer);
      if(localStorage.getItem('token')){
        (this as any).timer = setTimeout(() => {
          (this as any).getListNew();
        }, 10000);
      }
    },

    async getList() {
      if (!(this as any).listParem.account_nos) {
        return;
      }
      let initTableData: any = [];
      let tableData: any = [];
      (this as any).socketTransaction((this as any).listParem.account_nos, () => {
        (this as any).mySocketOnMsg();
      });
      // Toast.loading({
      //     duration: 0, // 持续展示 toast
      //     forbidClick: true,
      //     message: '加载中...',
      // });
      (this as any).isListLoad = true;
      await (this as any).$apis
        .querybatchorders((this as any).listParem, { "X-channel-id": (this as any).queryParem.type })
        .then(res => {
          Toast.clear();
          (this as any).isListLoad = false;
          (this as any).totalNum = res.data.total;

          res.data.order_infos && res.data.order_infos.forEach(item => {
            // (this as any).accountAll.push(item.account_no)
            // let isgo = false;
            // let order_status = item.order_status
            // if(order_status === 48 || order_status === 49 || order_status === 50 || order_status === 51
            // || order_status === 52 || order_status === 53){
            //     isgo = true;
            // }
            // item.isgo = isgo;

            if (item.can_cancel === 1) {
              let obj = JSON.parse(JSON.stringify(item));
              obj.can_cancel = 2;
              tableData.push(obj, item);
            } else {
              tableData.push(item);
            }
            initTableData.push(item);
          });
          (this as any).initTableData = initTableData;
          (this as any).tableData = tableData;
          (this as any).loading = false;
          // 
          if ((this as any).initTableData.length >= (this as any).totalNum) {
            (this as any).finished = true;
          }
        })
        .catch(e => {
          (this as any).isListLoad = false;
          Toast.clear();
          
        });
    },
    async onLoad() {
      const _this = this as any;
      const box: any = document.getElementById("app");
      if (box.scrollTo) {
        box.scrollTo(0, 250);
      } else {
        box.scrollTop = 0;
      }
      if ((this as any).isListLoad) {
        return;
      }
      if ((this as any).refreshing) {
        (this as any).initTableData = [];
        (this as any).accountAll = [];
        (this as any).isLoadList = false;

        (this as any).batchParem.page = 0;
        (this as any).batchTotalNum = 0;
        (this as any).batchParem.symbol = "";
        (this as any).batchListData = [];
      }

      _this.loading = true;
      // (this as any).listParem.page++;
      await _this.getListNew();
      _this.loading = false;

      (this as any).onBatchLoad();
    },
    async onRefresh() {
      const _this = this as any;
      _this.restDataForRefreshing();

      await _this.onLoad();
      _this.refreshing = false;
    },
    onSonConfirm(value, index) {
      (this as any).$refs.checkboxGroup.toggleAll(false);
      (this as any).$nextTick(()=>{
        // 
        (this as any).popupShow = false;
        (this as any).batchGoods = (this as any).groupColumns[index];
        // 
        if (index === 0) {
          (this as any).batchParem.symbol = "";
        } else {
          // 
          (this as any).batchParem.symbol = (this as any).symbolList[index - 1].code;
        }
        (this as any).batchFinished = false;
        (this as any).batchParem.page = 0;
        (this as any).batchTotalNum = 0;
        (this as any).batchListData = [];
        (this as any).onBatchLoad();
      })
    },
    onSonChange(picker, value, index) {
      
    },
    onSonCancel() {
      
      (this as any).popupShow = false;
    },
    /**
     * @Description PC端兼容滑动 tableMouseDown、tableMouseMove、tableMouseUp、allTableMouseMove、allTableMouseUp、allTableMouseLeave
     * @date 2024/1/8
     * @param
     * @return {void}
     */
    tableMouseDown(e, mouseObj, refStr) {
      let _this = (this as any);
      mouseObj.isDragging = true;
      mouseObj.startX = e.clientX;
      mouseObj.startScrollLeft = _this.$refs[refStr].scrollLeft;
    },
    tableMouseMove(e, mouseObj, refStr) {
      let _this = (this as any);
      if (mouseObj.isDragging) {
        const deltaX = e.clientX - mouseObj.startX;
        _this.$refs[refStr].scrollLeft = mouseObj.startScrollLeft - deltaX;
      }
    },
    tableMouseUp(e, mouseObj) {
      mouseObj.isDragging = false;
    },
    allTableMouseMove(e) {
      let _this = (this as any);
      _this.tableMouseMove(e, _this.tableMouseObj, "tableList");
      _this.tableMouseMove(e, _this.sonTableMouseObj, "sonTableList");
    },
    allTableMouseUp(e) {
      let _this = (this as any);
      _this.tableMouseUp(e, _this.tableMouseObj);
      _this.tableMouseUp(e, _this.sonTableMouseObj);
    },
    allTableMouseLeave(e) {
      let _this = (this as any);
      _this.tableMouseUp(e, _this.tableMouseObj);
      _this.tableMouseUp(e, _this.sonTableMouseObj);
    },
    /**
     * @Description 重新刷新前的准备动作，
     * @date 2024/1/17
     * @return {void}
     */
    restDataForRefreshing() {
      let _this = (this as any);

      // van-list相关数据
      _this.finished = false;

      // 列表相关数据
      _this.tableData = [];

      // 分页请求相关数据
      _this.listParem.page = 0;
      _this.totalNum = 0;
    }
  },
  destroyed() {
    clearTimeout((this as any).timer)
    clearTimeout((this as any).batchTimer);
    (window as any).removeEventListener('visibilitychange', (this as any).visibilityFn);
  }
};
